
import { defineComponent } from "vue";
import FooterContainer from "Components/common/Footer/FooterContainer.vue";
import menuFactory, { isActionActive, actionList, actionKey } from "Common/Footer/menuAction";
import Context from "Helpers/actionContext";
import { IActionLinkItem } from "Models";


export default defineComponent({
  components: { FooterContainer },
  data() {
    return {
      items: actionList,
      context: new Context(new menuFactory(this))
    };
  },
  methods: {
    onMenuClick(item: IActionLinkItem) {
      this.context.executeAsync(item.name, item);
    },
    isActive(item: IActionLinkItem) {
      return isActionActive(item, this.$route);
    },
  },
});
